import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

const Inquiry = () => {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [contents, setContents] = useState<string>("");
  const [type, setType] = useState<string>("");
  const [elev, setElev] = useState<string>("");
  const [service, setservice] = useState<string>("");

  // const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name || !phone || !address) {
      Swal.fire({
        title: "이름, 연락처, 주소를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    // setLoading(true);

    await axios
      .post("/api/contact", {
        name: name,
        phone: phone,
        address: address,
        contents: contents,
        type: type,
        elev: elev,
        service: service,
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        // setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };
  return (
    <section className="w-full bg-white">
      <div className="mx-auto max-w-[1200px] px-4 md:px-8">
        <h3 className="text-center font-light text-font">대한민국 전지역 어디든지 문의만 주시면 달려갑니다</h3>

        <form className="mt-8 flex flex-col gap-6 md:mt-10 lg:flex-row" onSubmit={(e) => e.preventDefault()}>
          {/* Required fields */}
          <div className="flex-1 lg:flex-[1.3]">
            <p className="mb-2 text-sm text-red">* 필수기재사항</p>
            <div className="space-y-3">
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <input
                  type="text"
                  value={name}
                  id="name"
                  onChange={(e) => setName(e.target.value)}
                  placeholder="이름을 입력하세요"
                  className="rounded-md bg-gray-100 px-4 py-3.5 text-center text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#F4791C]/40"
                />
                <input
                  type="tel"
                  value={phone}
                  maxLength={11}
                  id="phone"
                  onChange={(e) => setPhone(e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1"))}
                  placeholder="연락처를 입력하세요"
                  className="rounded-md bg-gray-100 px-4 py-3.5 text-center text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#F4791C]/40"
                />
              </div>
              <input
                type="text"
                id="address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="주소를 입력하세요"
                className="w-full rounded-md bg-gray-100 px-4 py-3.5 text-center text-sm text-gray-700 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#F4791C]/40"
              />
              <textarea
                value={contents}
                name="contents"
                id="contents"
                onChange={(e) => setContents(e.target.value)}
                placeholder="내용을 입력해주세요"
                rows={4}
                className="w-full resize-none rounded-md bg-gray-100 px-4 py-3.5 text-center text-sm text-gray-700 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#F4791C]/40"
              />
            </div>
          </div>

          {/* Optional fields */}
          <div className="flex-1 text-font">
            <p className="mb-2 text-sm ">* 선택기재사항</p>
            <div className="space-y-3">
              <input
                type="text"
                value={type}
                id="type"
                onChange={(e) => setType(e.target.value)}
                placeholder="건물의 형태 (ex. 아파트, 주택 등)"
                className="w-full rounded-md border border-gray-200 px-4 py-3.5 text-center text-sm text-gray-700 placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-[#F4791C]/40"
              />
              <input
                type="text"
                value={elev}
                id="elev"
                onChange={(e) => setElev(e.target.value)}
                placeholder="엘리베이터 유무"
                className="w-full rounded-md border border-gray-200 px-4 py-3.5 text-center text-sm text-gray-700 placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-[#F4791C]/40"
              />
              <input
                type="text"
                value={service}
                id="service"
                onChange={(e) => setservice(e.target.value)}
                placeholder="희망 서비스"
                className="w-full rounded-md border border-gray-200 px-4 py-3.5 text-center text-sm text-gray-700 placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-[#F4791C]/40"
              />
              <p className="text-center">기재사항 중 필수 항목만 작성하셔도 됩니다</p>
            </div>
          </div>
        </form>

        {/* Agreement + submit */}
        <div className="mt-6 lg:flex flex-col items-stretch gap-3 sm:flex-row sm:items-center">
          <label className="flex shrink-0 items-center justify-start gap-2 text-sm text-gray-600 mb-2 lg:mb-0">
            <input
              defaultChecked
              checked
              type="checkbox"
              className="h-4 w-4 rounded-full border-gray-300 text-primary focus:ring-[#F4791C]"
            />
            개인정보 처리방침 동의
          </label>
          <button
            type="button"
            onClick={handlerPostContact}
            className="flex-1 rounded-md bg-primary py-3.5 text-sm w-full font-bold text-white transition-colors hover:bg-[#e0690f] md:text-base"
          >
            상담 접수 바로가기
            <br className="block lg:hidden" />( 기재사항을 다시한번 확인해주세요 )
          </button>
        </div>

        {/* Footer brand row */}
        <div className="mt-8 flex flex-col items-center justify-start gap-4 lg:gap-10 border-t border-gray-100 pt-8 sm:flex-row">
          <img
            src={"/images/logo.png"}
            alt="바우하우스 BAUHAUS 로고"
            className="relative w-auto h-full max-h-20 hidden lg:block"
          />
          <a href="tel:010-5629-0176">
            <img
              src={"/images/num.png"}
              alt="무료견적 365일 24시간 출장가능 010.5629.0176"
              className="relative w-auto h-full max-h-20"
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Inquiry;
